import type { ExperimentConfig } from '../types'
import { Hashing } from '../utils/hashing'
import { getStatsigData } from '../utils/storage'

export function getExperiment(experimentName: string): ExperimentConfig | null {
  try {
    const data = getStatsigData()
    const experimentNameHash = Hashing.djb2Hash(experimentName)

    const experimentConfig = data.dynamic_configs[experimentNameHash]

    if (!experimentConfig) {
      console.error(`Experiment "${experimentName}" not found`)

      return null
    }

    return experimentConfig
  } catch (error) {
    console.error('Error evaluating experiment:', error)

    return null
  }
}

export function useGetExperiment(
  experimentName: string
): ExperimentConfig | null {
  return getExperiment(experimentName)
}
